import { Grid } from "@mui/material";

import {
  ActiveTextEighteen,
  TextFifteenYellow,
} from "../../css components/Style";
import { useSelector } from "react-redux";

export default function FieldName({ formikProps }) {
  const { siteColors } = useSelector((state) => state.renderUIDetails);

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextFifteenYellow>Column Names</TextFifteenYellow>
        </Grid>

        <Grid item xs={12}>
          <ActiveTextEighteen color={siteColors?.primary}>
            {formikProps.values.fieldNames}
          </ActiveTextEighteen>
        </Grid>
      </Grid>
    </Grid>
  );
}
